// ======================================
// Packages Page Module
// ======================================

import { icons, renderPackageCard } from '../components.js';
import { packagesAPI } from '../lib/api.js';

export function renderPackagesPage() {
  return `
    <section class="page-header">
      <div class="container">
        <div class="page-header-content">
          <h1 class="page-title">Interior Packages</h1>
          <p class="page-subtitle">
            All-inclusive packages designed for different budgets. 
            Transparent pricing with no hidden costs.
          </p>
        </div>
      </div>
    </section>

    <section class="section packages-section">
      <div class="container">
        <div class="packages-grid" id="packages-container">
          <!-- Loading Skeleton -->
          <div style="grid-column: 1/-1; text-align: center; padding: 4rem;">
            <div class="spinner"></div>
            <p style="margin-top: 1rem; color: var(--color-text-muted);">Loading packages...</p>
          </div>
        </div>
      </div>
    </section>

    <!-- What's Included Section -->
    <section class="section comparison-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">What's Included</h2>
          <p class="section-subtitle">
            Compare our packages to find the right fit for your home.
          </p>
        </div>
        <div class="comparison-table-wrapper">
            <!-- Static comparison table for now, or could be dynamic too -->
          <table class="comparison-table">
            <thead>
              <tr>
                <th>Feature</th>
                <th>Essential</th>
                <th>Premium</th>
                <th>Luxe</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Modular Kitchen</td>
                <td><span class="check">${icons.check}</span></td>
                <td><span class="check">${icons.check}</span></td>
                <td><span class="check">${icons.check}</span></td>
              </tr>
              <tr>
                <td>Wardrobes (per BHK)</td>
                <td><span class="check">${icons.check}</span></td>
                <td><span class="check">${icons.check}</span></td>
                <td><span class="check">${icons.check}</span></td>
              </tr>
               <tr>
                <td>False Ceiling</td>
                <td><span class="x">${icons.x}</span></td>
                <td><span class="check">${icons.check}</span></td>
                <td><span class="check">${icons.check}</span></td>
              </tr>
              <tr>
                <td>Wall Painting</td>
                <td><span class="x">${icons.x}</span></td>
                <td><span class="x">${icons.x}</span></td>
                <td><span class="check">${icons.check}</span></td>
              </tr>
              <tr>
                <td>Warranty</td>
                <td>10 Years</td>
                <td>10 Years</td>
                <td>10 Years</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="text-align: center; margin-top: var(--space-8);">
          <a href="/estimator" class="btn btn-primary btn-lg">Get Custom Quote</a>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="section cta-section">
      <div class="container">
        <div class="cta-content">
          <h2 class="cta-title">Need a Custom Package?</h2>
          <p class="cta-subtitle">
            We can create a package tailored exactly to your needs and budget.
          </p>
          <button class="btn btn-lg cta-btn" data-open-modal="lead-modal">
            Talk to Our Experts
          </button>
        </div>
      </div>
    </section>
  `;
}

export async function initPackagesPage() {
  const container = document.getElementById('packages-container');
  if (!container) return;

  try {
    const response = await packagesAPI.list();
    const packages = response.data || [];

    if (packages.length === 0) {
      container.innerHTML = `
                <div style="grid-column: 1/-1; text-align: center; padding: 4rem;">
                    <p>No packages available at the moment.</p>
                </div>
            `;
      return;
    }

    container.innerHTML = packages.map((pkg, i) => {
      // Helper to match component expectations
      const features = Array.isArray(pkg.features) ? pkg.features : [];
      return renderPackageCard({
        type: pkg.type,
        name: pkg.name,
        price: pkg.price,
        features: features // Array of {name, included}
      }, pkg.is_featured);
    }).join('');

  } catch (error) {
    console.error('Failed to load packages:', error);
    container.innerHTML = `
            <div style="grid-column: 1/-1; text-align: center; padding: 4rem; color: var(--color-error);">
                <p>Failed to load packages. Please try again later.</p>
                <button class="btn btn-outline btn-sm mt-4" onclick="location.reload()">Retry</button>
            </div>
        `;
  }
}
